/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../client.ts';
import type {
  TelegramNotificationsUserControllerSubscribeToFcmMutationRequest,
  TelegramNotificationsUserControllerSubscribeToFcmMutationResponse,
  TelegramNotificationsUserControllerSubscribeToFcm401,
} from '../types/TelegramNotificationsUserControllerSubscribeToFcm.ts';

function getTelegramNotificationsUserSubscribeToFcmUrl() {
  const res = { method: 'POST', url: `/api/user/telegram/notifications/subscribe-fcm` as const };
  return res;
}

/**
 * {@link /api/user/telegram/notifications/subscribe-fcm}
 */
export async function telegramNotificationsUserSubscribeToFcm(
  data: TelegramNotificationsUserControllerSubscribeToFcmMutationRequest,
  config: Partial<RequestConfig<TelegramNotificationsUserControllerSubscribeToFcmMutationRequest>> & {
    client?: typeof fetch;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    TelegramNotificationsUserControllerSubscribeToFcmMutationResponse,
    ResponseErrorConfig<TelegramNotificationsUserControllerSubscribeToFcm401>,
    TelegramNotificationsUserControllerSubscribeToFcmMutationRequest
  >({
    method: 'POST',
    url: getTelegramNotificationsUserSubscribeToFcmUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  });
  return res.data;
}
